export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5216.ade01420.jpg";